import { Slide1ExecSummary } from './Slide1ExecSummary'
import { Slide2KPIs } from './Slide2KPIs'
import { Slide3Challenge } from './Slide3Challenge'
import { Slide4Opportunity } from './Slide4Opportunity'
import { Slide5Solution } from './Slide5Solution'
import { Slide6Stage1 } from './Slide6Stage1'
import { Slide7Stage2 } from './Slide7Stage2'
import { Slide8Portfolio } from './Slide8Portfolio'
import { Slide9Wave1 } from './Slide9Wave1'
import { SlideCampaignFlow } from './SlideCampaignFlow'
import { Slide10Wave2 } from './Slide10Wave2'
import { Slide11Measurement } from './Slide11Measurement'
import { Slide12NextSteps } from './Slide12NextSteps'

export const slides = [
  Slide1ExecSummary,
  Slide2KPIs,
  Slide3Challenge,
  Slide4Opportunity,
  Slide5Solution,
  Slide6Stage1,
  Slide7Stage2,
  Slide8Portfolio,
  Slide9Wave1,
  SlideCampaignFlow,
  Slide10Wave2,
  Slide11Measurement,
  Slide12NextSteps,
]

export const slideTitles: { section: string; title: string }[] = [
  { section: 'Cover', title: 'Executive Summary' },
  { section: '1', title: 'What the KPI funnel tells us' },
  { section: '2', title: 'The Challenge' },
  { section: '3', title: 'The Opportunity' },
  { section: '4', title: 'The Snakker Solution' },
  { section: '5', title: 'Stage 1: Snakkify DermaWorld Anzupgo pages' },
  { section: '6', title: 'Stage 2: Activate the Market' },
  { section: '7', title: 'Campaign Portfolio Recommendation' },
  { section: '8', title: 'Recommended Wave 1 Package' },
  { section: '9', title: 'Campaign Flow Example' },
  { section: '10', title: 'Wave 2 Expansion' },
  { section: '11', title: 'Measurement & Optimization' },
  { section: '12', title: 'Next Steps' },
]
